module.exports = __webpack_public_path__ + "img/max-file-transfer--json.e25f3d10.svg";